<template>
  <el-dialog
    width="43.75rem"
    title="设置分数"
    :close-on-click-modal="false"
    :visible.sync="inVisible"
    class="grade-dialog"
    :modal="true"
  >
    <div class="grade-page">
      <div class="top">
        <div>序号</div>
        <div>题干</div>
        <div>设置分数</div>
      </div>
      <div class="grade-area">
        <div v-for="(i, k) in bucketData" :key="k">
          <div class="grade-title">
            <div class="title">{{ i.title }}（共{{ i.score }}分）</div>
            <div class="min">
              <div class="left-text">每题</div>
              <div>
                <el-input-number
                  v-model="i.quesScore"
                  :controls="false"
                  :min="0"
                  :max="100"
                  :precision="0"
                  @input="value => scoreChange(value, i)"
                  class="per-input"
                ></el-input-number>
              </div>
              <div class="right-text">分</div>
            </div>
          </div>
          <div class="questions">
            <div class="question" v-for="(item, index) in i.data" :key="index">
              <div class="left-area">
                <div class="order-number">{{ index + 1 }}</div>

                <div
                  class="test-content"
                  style="display: flex;"
                  v-html="item.questionStem"
                ></div>
              </div>
              <div class="right-area">
                <el-input-number
                  @input="value => scoreTypeChange(value, i)"
                  v-model="item.score"
                  class="input-style"
                  :controls="false"
                  :min="0"
                  :precision="0"
                  :max="100"
                ></el-input-number>

                <div class="text-style">分</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-area">
        <span>总分数：</span>
        <span>{{ totalPoints }}分</span>
      </div>
      <div class="footer-area">
        <el-button @click="inVisible = false">关闭</el-button>
        <el-button type="primary" @click="submitGrade">提交</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      paperData: {},
      inVisible: false,
      totalPoints: 0,
      bucketData: {
        1: {
          title: "一、单选题",
          data: [],
          quesScore: "",
          score: 0
        },
        2: {
          title: "二、判断题",
          data: [],
          quesScore: "",
          score: 0
        },
        3: {
          title: "三、多选题",
          data: [],
          quesScore: "",
          score: 0
        }
      }
    };
  },
  computed: {},
  methods: {
    setTotal() {
      let total = 0;
      for (let i in this.bucketData) {
        for (let j in this.bucketData[i].data) {
          total += Number(this.bucketData[i].data[j].score);
          console.log(total);
        }
      }
      this.totalPoints = Number(total);
    },
    open(paper, data) {
      this.paperData = paper;
      Object.entries(JSON.parse(JSON.stringify(data))).forEach(item => {
        this.bucketData[item[0]] = {
          ...item[1],
          quesScore: 0,
          score: item[1].data.reduce(function(total, val) {
            return total + Number(val.score || 0);
          }, 0)
        };
      });
      this.setTotal();
      this.inVisible = true;
    },
    scoreChange(value, i) {
      i.data.forEach(item => {
        item.score = value;
      });
      i.score = Number(value * i.data.length);
      this.$forceUpdate();
      console.log(i.score);
      this.setTotal();
    },
    scoreTypeChange(value, i) {
      let res = 0;
      i.data.forEach(item => {
        res += Number(item.score);
      });
      i.score = res;
      this.$forceUpdate();
      this.setTotal();
    },
    submitGrade() {
      this.$message({
        showClose: true,
        message: "分数保存成功",
        type: "success"
      });
      this.$emit("setScore", this.bucketData);
      this.inVisible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.grade-dialog {
  /deep/ .el-dialog {
    margin: 0 !important;
    margin-left: 39rem !important;
    margin-top: 4.375rem !important;
    // position: fixed!important;
    // top: 0;
    // left: 10rem;
  }

  /deep/.el-dialog__header {
    background: #1890ff;
    text-align: center;
    border-radius: 5px 5px 0px 0px;
    height: 2.8125rem !important;
    line-height: 2.8125rem;
    padding: 0;
  }

  /deep/ .el-dialog__title {
    font-size: 1rem;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #ffffff;
  }

  /deep/ .el-dialog__body {
    padding: 0;
  }

  .grade-page {
    box-sizing: border-box;
    // border-top: 1px solid #eff1f4;
    // border-bottom: 1px solid #eff1f4;
    // padding: 0px 30px 11px 27px;
    // position: ;
    padding: 1.25rem;

    .bottom-area {
      margin-top: 0.5rem;
    }

    .footer-area {
      // position: absolute;
      // bottom: 0;
      // right: 0;
      margin-top: 0.5rem;
      text-align: right;
      // float: right;
    }

    .top {
      width: 41.25rem;
      height: 2.5rem;
      line-height: 2.5rem;
      background: #e4efff;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 1.5rem 0 0.75rem;
    }

    .grade-area {
      overflow: auto;
      height: 40rem;
      box-sizing: border-box;

      .grade-title {
        display: flex;
        justify-content: space-between;
        height: 3rem;
        line-height: 3rem;
        align-items: center;
        padding: 0 1rem;
        box-sizing: border-box;

        .min {
          display: flex;
          align-items: center;

          /deep/ .per-input {
            width: 3rem;
            height: 2rem;
          }

          /deep/ .el-input__inner {
            height: 2rem;
            line-height: 2rem;
            padding: 0 0.7rem;
            font-size: 0.875rem;
            font-family: PingFangSC-Regular, PingFang SC;
          }

          .right-text {
            margin-left: 0.5rem;
          }
          .left-text {
            margin-right: 0.5rem;
          }
        }
      }

      .questions {
        box-sizing: border-box;

        .question {
          display: flex;
          justify-content: space-between;
          box-sizing: border-box;
          border: 1px solid #e5eaf4;
          border-top: none;
          // height: 2.5rem;
          line-height: 2.5rem;
          padding-right: 1rem;

          .left-area {
            display: flex;
            // align-items: center;
            // justify-content: center;
            align-content: center;
            // width: 80%;
            border-right: 1px solid #e5eaf4;

            box-sizing: border-box;

            .order-number {
              border-right: 1px solid #e5eaf4;
              // height: 100%;
              // line-height: 100%;
              width: 10%;
              height: 100%;
              text-align: center;
              width: 2.5rem;
            }

            .test-content {
              box-sizing: border-box;
              // width: 90%;
              width: 31rem;
              padding: 0 1rem;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              line-break: anywhere;
            }
          }

          .right-area {
            display: flex;
            // align-items: center;
            // align-items: center;
            // justify-content: right;
            // border: 1px solid red;
            // width: 20%;
            box-sizing: border-box;
            // border: 1px solid #E5EAF4;
            border-left: none;

            .input-style {
              text-align: center;
              width: 3rem;
              height: 2rem;
            }

            /deep/ .el-input__inner {
              height: 2rem;
              line-height: 2rem;
              padding: 0 0.7rem;
              font-size: 0.875rem;
              font-family: PingFangSC-Regular, PingFang SC;
              box-sizing: border-box;
            }

            .text-style {
              // display: inline;
              margin-left: 0.5rem;
            }
          }
        }

        .question:nth-child(1) {
          border-top: 1px solid #e5eaf4;
        }
      }
    }
  }
}
&::-webkit-scrollbar {
  width: 3px;
}

// 滚动条里面默认的小方块,自定义样式
&::-webkit-scrollbar-thumb {
  background: #8798af;
  border-radius: 2px;
}

// 滚动条里面的轨道
&::-webkit-scrollbar-track {
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/views/Paper/Theory/ScoreDialog.vue